import React from 'react';
import BusinessParamForm from '../../../../forms/maintenance/BusinessParamForm'

export default function BusinessParameters(props) {

    return (
        <>
            <div className="col-12">
                <BusinessParamForm handledUpdateIva={props.handledUpdateIva} paramInfoIva={props.paramInfoIva} paramInfoData={props.paramInfoData} handledEdit={props.handledEdit} handledDelete={props.handledDelete} handledNew={props.handledNew}/>
            </div>
        </>
    )
}




